import { Fragment } from 'react';
import { sanitize } from 'sanitize-text/sanitizers/Sanitize';
import { config } from 'sanitize-text/sanitizers/SanitizeConfiguration';
import { clearSearch, search, setSearchQuery } from '../../../actions/SearchActions';
import { SEARCH, SEARCH_ACTIONS, SEARCH_ORIGINS } from '../../../tracking/trackerActions';
import { getUsageTracker } from '../../../utils/usage-tracker/index';
import { Paths } from '../../RoutesPublic';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const resultPerPage = 10;
const getSanitizedAndEncodedQuery = query => {
  if (!query) return query;
  const sanitizedQuery = sanitize(query, config.TEXTONLY);
  const sanitizedAndEncodedQuery = encodeURIComponent(sanitizedQuery);
  return sanitizedAndEncodedQuery;
};
export const getSearchResultsPageUrl = (query, pageValue) => {
  if (!query) {
    return Paths.SEARCH;
  }
  const updatedPath = `${Paths.SEARCH}?q=${getSanitizedAndEncodedQuery(query)}${pageValue ? `&page=${pageValue}` : ''}`;
  return updatedPath;
};
export const getOffsetFromPage = page => {
  return page && (page - 1) * resultPerPage;
};
export const searchSanitizedAndEncodedQuery = (query, locale, lastQuery, dispatch, isOnType, page) => {
  if (query === lastQuery) return;
  if (!query) {
    dispatch(clearSearch());
    return;
  }
  const sanitizedQuery = getSanitizedAndEncodedQuery(query);
  dispatch(setSearchQuery({
    query
  }));
  dispatch(search(sanitizedQuery, locale, getOffsetFromPage(page)));
  getUsageTracker().track(SEARCH, {
    action: SEARCH_ACTIONS.SUBMITTED,
    origin: isOnType ? SEARCH_ORIGINS.DROPDOWN_SEARCH : SEARCH_ORIGINS.STANDARD_SEARCH,
    searchTerm: query
  });
};
export const boldQuery = (text, query) => {
  if (!query) return text;

  // Convert the text and the query to lower case for case-insensitive comparison
  const lowerCaseText = text.toLowerCase();
  const lowerCaseQuery = query.toLowerCase();

  // Initialize the current index to keep track of the position in the original text
  let currentIndex = 0;

  // Split the lower case text by the lower case query and map over each segment
  return lowerCaseText.split(lowerCaseQuery).map((item, i, all) => {
    // Extract the corresponding part of the original text for the current segment
    const originalText = text.substring(currentIndex, currentIndex + item.length);
    // Increment the current index by the length of the current segment
    currentIndex += item.length;

    // If it's not the last segment, also extract the original query
    if (i < all.length - 1) {
      const originalQuery = text.substring(currentIndex, currentIndex + query.length);
      // Increment the current index by the length of the query
      currentIndex += query.length;

      // Return the current segment and the query, with the query wrapped in a <strong> tag
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [originalText, /*#__PURE__*/_jsx("strong", {
          children: originalQuery
        })]
      }, i);
    } else {
      // If it's the last segment, just return the segment
      return /*#__PURE__*/_jsx(Fragment, {
        children: originalText
      }, i);
    }
  });
};

/** This is used for getting the anchor tag and scrolling the page into view when
 * the search result selected is on the current page.
 * See https://regexr.com/7l7sh for details on the parts & to play around with this regex.
 */
export const URL_REGEX = /^(https?:\/\/)?([/a-z/]*\.[A-Za-z0-9-_]{2}.)?([A-Za-z0-9-_~:/?[\]@!$&'()*+,;=%]*)?(?:#)?([\d%-\w]*)?$/;
export const searchResultBadgeIsApiEndpoint = type => {
  return ['GET', 'PUT', 'POST', 'PATCH', 'DELETE'].includes(type);
};